
import { defineComponent, reactive, toRefs, onMounted, unref } from "vue";
import { clone, parseError } from "@/generic";
import { Prefecture } from "@/client/schema";
import {
  useUpdateOneOuterCartonParamMutation,
  useGetOneOuterCartonParamQuery,
  useCreateAutoTypesettingMutation,
  useUpdateAutoTypesettingMutation,
} from "@/client/modules/api";
import { useGetSession } from "@/client/modules/session";
import { InputZipCode } from "@/generic";
import { usePostalCode } from "@/shared/modules/postalCode";
import { InputCurrency } from "@/generic/components/entry";

export type Props = {
  outerCartonParamId: string;
  forTypesetting: boolean;
  previewOnly: boolean;
  typesettingPreviewFlag: boolean;
};

const fallbackImage =
  "data:image/png;base64,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";

export default defineComponent({
  components: {
    InputZipCode,
    InputCurrency,
  },
  props: {
    outerCartonParamId: {
      type: String,
      required: true,
    },
    forTypesetting: {
      type: Boolean,
      required: false,
      default: false,
    },
    previewOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    typesettingPreviewFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["change"],
  setup(props: Props) {
    const state = reactive({
      outerCartonParam: null as null | any,
      visiblePdfCreate: false,
      visiblePdfPreview: true,
      editPdfPath: null as null | string,
      errorMessages: [] as string[],
    });

    const { loading, onResult, refetch } = useGetOneOuterCartonParamQuery(
      {
        id: props.outerCartonParamId,
      },
      {
        fetchPolicy: "network-only",
      }
    );
    onResult((result) => {
      state.outerCartonParam = clone(result.data.outerCartonParam);
    });

    const prefectures = Object.values(Prefecture);

    const handleVisiblePdfCreate = () => {
      state.visiblePdfCreate = true;
      state.visiblePdfPreview = false;
    };

    const handleVisiblePdfPreview = () => {
      state.visiblePdfCreate = false;
      state.visiblePdfPreview = true;
    };

    const { searchAddress } = usePostalCode();
    const handleSearch = async () => {
      const _addressModel = unref(state.outerCartonParam);
      if (_addressModel.zipCode == null || _addressModel.zipCode.length === 0)
        return;

      const result = await searchAddress(_addressModel.zipCode);

      if (result.length > 0) {
        const address = result[0];
        state.outerCartonParam.prefecture =
          prefectures[Number(address.prefCode) - 1];
        state.outerCartonParam.city = address.city;
        state.outerCartonParam.block = address.town;
        state.outerCartonParam.building = address.office || "";
      }
      handleUpdate();
    };

    const { mutate: createAutoTypesetting, error: createHxError } =
      useCreateAutoTypesettingMutation({});
    const handleAutoTypesetting = async () => {
      try {
        handleUpdate();
        if (state.outerCartonParam?.orderProduct == null) return;
        await createAutoTypesetting({
          input: {
            id: state.outerCartonParam.orderProduct.id,
          },
        });
        state.visiblePdfCreate = false;
        state.visiblePdfPreview = true;
      } catch (e) {
        if (createHxError.value == null) throw e;
        state.errorMessages = parseError(createHxError);
      }
    };

    const { currentUser } = useGetSession();
    const { mutate: updateAutoTypesetting, error: updateHxError } =
      useUpdateAutoTypesettingMutation({});
    const handleEditpdf = async () => {
      try {
        if (state.outerCartonParam?.orderProduct == null) return;
        const result = await updateAutoTypesetting({
          input: {
            id: state.outerCartonParam.orderProduct.id,
          },
        });
        const data = result?.data?.updateAutoTypesetting;
        if (data) {
          const fileKey = data.fileKey;
          const clientUserId = unref(currentUser).id;
          const orderProductId = state.outerCartonParam.orderProduct.id;
          const backUrl = `${location.origin}/api/app/sonbp_callback/${fileKey}/${clientUserId}/${orderProductId}`;
          const editPdfParams: { [key: string]: any } = {};
          editPdfParams["access_token"] = data.accessToken;
          editPdfParams["file_key"] = fileKey;
          editPdfParams["back_url"] = backUrl;
          const editPdfQuery = new URLSearchParams(editPdfParams);
          const editPdfPath = `${data.sonbpUri}?${editPdfQuery}`;
          window.location.href = editPdfPath;
        }
      } catch (e) {
        if (updateHxError.value == null) throw e;
        state.errorMessages = parseError(updateHxError);
      }
    };

    onMounted(() => {
      state.visiblePdfPreview = props.typesettingPreviewFlag;
    });

    const { mutate: update, error: updateError } =
      useUpdateOneOuterCartonParamMutation({});

    const handleUpdate = async () => {
      const safeOuterCartonParam = state.outerCartonParam;
      try {
        if (safeOuterCartonParam == null) return;
        state.errorMessages = [];
        await update({
          input: {
            id: props.outerCartonParamId,
            poNumber: safeOuterCartonParam.poNumber,
            countryOfOrigin: safeOuterCartonParam.countryOfOrigin,
            productName: safeOuterCartonParam.productName,
            janCode: safeOuterCartonParam.janCode,
            taxIncludedPrice: safeOuterCartonParam.taxIncludedPrice,
            quantityPerCartonText: safeOuterCartonParam.quantityPerCartonText,
            supplierName: safeOuterCartonParam.supplierName,
            zipCode: safeOuterCartonParam.zipCode,
            prefecture: safeOuterCartonParam.prefecture,
            city: safeOuterCartonParam.city,
            block: safeOuterCartonParam.block,
            building: safeOuterCartonParam.building,
          },
        });

        await refetch();
      } catch (e) {
        if (updateError.value == null) throw e;
        state.errorMessages = parseError(updateError.value);
      }
    };

    const handleClose = () => {
      state.visiblePdfCreate = false;
      state.visiblePdfPreview = false;
    };

    return {
      fallbackImage,
      ...toRefs(state),
      prefectures,
      loading,
      handleVisiblePdfCreate,
      handleVisiblePdfPreview,
      handleSearch,
      handleAutoTypesetting,
      handleEditpdf,
      handleUpdate,
      handleClose,
    };
  },
});
